import styled from "@emotion/styled";
import { KonturColors } from "@skbkontur/colors";
import { ArrowADownIcon16Light } from "@skbkontur/icons";

import { sizeToken } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";

import ListOpenIcon from "./arrow-c-down-16-light.svg";
import ListCloseIcon from "./arrow-c-right-16-light.svg";

export const FlexNodeLabelContainer = styled.div({
    display: "flex",
    gap: "8px",
});

export const FieldSet = styled.div({
    border: "none",
    borderLeft: `1px solid ${KonturColors.grayscaleBackground}`,
    padding: 0,
    paddingLeft: sizeToken(2.5),
    marginLeft: sizeToken(1),
});

export const MultipleNodeLabel = styled.div({
    fontWeight: 700,
    padding: "4px 0px",
    lineHeight: 1.7,
    flex: 100,
    display: "flex",
    cursor: "pointer",
});

export const MultipleLeafLabel = styled.div({
    marginLeft: sizeToken(1),
    fontWeight: 400,
    padding: "2px",
    lineHeight: 2,
    display: "flex",
    cursor: "pointer",
});

export const ArrowIcon = styled.div<{ opened: boolean }>(props => ({
    backgroundImage: `url(${props.opened ? ListOpenIcon : ListCloseIcon})`,
    backgroundRepeat: "no-repeat",
    height: sizeToken(3),
    width: sizeToken(3),
    padding: "0 4px 4px 0",
    flex: 2,
    transform: "translateY(3px)",
    cursor: "pointer",
}));

export const SingleNodeLabel = styled.div<{ withHover: boolean; isPicked: boolean; isLeaf: boolean }>(props => ({
    marginLeft: sizeToken(1),
    padding: "4px 8px",
    fontWeight: props.isLeaf ? 400 : 700,
    lineHeight: 1.7,
    flex: 100,
    display: "flex",

    backgroundColor: props.isPicked ? KonturColors.grayscaleBackground : "inherit",
    borderRadius: sizeToken(1),

    ":hover": props.withHover
        ? {
              backgroundColor: KonturColors.grayscaleLightBackground,
              cursor: "pointer",
          }
        : {},
}));

export const CodeNodeLabel = styled.span<{ isCode: boolean }>(props => ({
    fontWeight: 400,
    color: props.isCode ? KonturColors.grayscaleSecondaryText : KonturColors.grayscaleText,
    marginRight: props.isCode ? sizeToken(2) : "inherit",
}));

export const ShowMoreArrowIcon = styled(ArrowADownIcon16Light)(() => ({
    color: KonturColors.grayscaleSecondaryText,
}));
